const DocumentContextMenuTestIdsScope = {
  DOCUMENT_CONTEXT_MENU: 'document-context-menu',
};

export const DocumentContextMenuTestIds = {
  MOVE_TYPE_SELECT: `${DocumentContextMenuTestIdsScope.DOCUMENT_CONTEXT_MENU}.move-type-select`,
  OPEN_WORKSHEET: `${DocumentContextMenuTestIdsScope.DOCUMENT_CONTEXT_MENU}.open-worksheet`,
};
